/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { CommonResponse } from 'src/app/models/commomResponse';
import { driverData, driverListResponse } from 'src/app/models/driverData';
import { geofenceData, geofenceListing } from 'src/app/models/geofenceData';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GeoFenceService {
  constructor(private http: HttpClient) { }

  getGeofenceListing(query: string): Observable<geofenceListing> {
    return this.http
      .get<{ data: geofenceListing }>(`${environment.base_url}zone?${query}`)
      .pipe(map(res => res.data));
  }

  getFeonceById(id: string): Observable<geofenceListing> {
    return this.http
      .get<{ data: geofenceListing }>(`${environment.base_url}zone/${id}`)
      .pipe(map(res => res.data));
  }

  getGeofenceList(): Observable<Array<{ name: string; _id: string }>> {
    return this.http
      .get<{
        data: Array<{ name: string; _id: string }>;
      }>(`${environment.base_url}zoneDropDown`)
      .pipe(map(res => res.data));
  }

  getDriverByZone(id: string | undefined): Observable<driverListResponse> {
    return this.http
      .get<{
        data: driverListResponse;
      }>(`${environment.base_url}getDriverByZone/${id}`)
      .pipe(map(res => res.data));
  }
  getDriverByGeofence(
    id: string | undefined,
    query: string
  ): Observable<Array<driverData>> {
    return this.http
      .get<{
        data: Array<driverData>;
      }>(`${environment.base_url}driverDropdownThroughGeoFence/${id}?${query}`)
      .pipe(map(res => res.data));
  }

  addGeoFence(data: geofenceData): Observable<CommonResponse> {
    return this.http.post<CommonResponse>(`${environment.base_url}zone`, data);
  }

  updateGeoFence(data: geofenceData, id: string): Observable<CommonResponse> {
    return this.http.put<CommonResponse>(
      `${environment.base_url}zone/${id}`,
      data
    );
  }

  deleteGeofence(id: string): Observable<number> {
    return this.http
      .delete<{ statusCode: number }>(`${environment.base_url}zone/${id}`)
      .pipe(map(res => res.statusCode));
  }
}
